import { createContext } from 'react'
import { FieldValidationHandler } from '../types'

export type FieldValidator = {
  [f: string]: FieldValidationHandler<any, any> | FieldValidationHandler<any, any>[]
}

export type AddRemoveFieldValidator = { (p: FieldValidator): { () } }

export type SetField<F> = { (fieldPath: string, setState: React.SetStateAction<F>) }

export type FieldErrors = { [fieldPath: string]: string[] }

export type SetFieldEvent<F, V> = {
  fieldPath: string
  value: Readonly<V> | null
  formValue: Readonly<F>
}

export type SetFieldListener<F = any, V = any> = { (e: SetFieldEvent<F, V>): any }

export type Context<V> = {
  value: V
  setValue: React.Dispatch<React.SetStateAction<V>>
  getValue: () => V
  disabled?: boolean
  setField: SetField<any>
  getField: { (fieldPath): any }
  addRemoveFieldValidator: AddRemoveFieldValidator
  fieldErrors?: FieldErrors
  onSubmit: React.FormEventHandler<any>
  addHtmlElementRef: (fieldPath: string, ref: React.RefObject<HTMLElement>) => () => void
  removeHtmlElementRef: (fieldPath: string, ref: React.RefObject<HTMLElement>) => void
  addSetFieldListener: (listener: SetFieldListener<V>) => void
  removeSetFieldListener: (listener: SetFieldListener<V>) => void
  autoValidation?: boolean | 'FORCE'
}

const FormContext = createContext<Context<any>>(null)
export default FormContext
